import { StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { HelmetProvider } from '@saas-pages/shared/public/seo'
import { initMetrika } from '@saas-pages/shared/public/runtime'
import branding from '../branding.config'
import { App } from './app/App'
import { I18nProvider } from './shared/i18n'
import './styles/index.css'

initMetrika(branding.metrikaId)

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element #root not found in the document.')
}

const app = (
  <StrictMode>
    <HelmetProvider>
      <I18nProvider>
        <App />
      </I18nProvider>
    </HelmetProvider>
  </StrictMode>
)

declare global {
  interface Window {
    __imgifyTestMount?: () => void
    __imgifyTestUnmount?: () => void
  }
}

let root = rootElement.hasChildNodes() ? null : createRoot(rootElement)

const mount = (): void => {
  root ??= createRoot(rootElement)
  root.render(app)
}

const unmount = (): void => {
  root?.unmount()
  root = null
}

if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, app)
} else {
  mount()
  if (import.meta.env.DEV) {
    window.__imgifyTestMount = mount
    window.__imgifyTestUnmount = unmount
  }
}
